import { FormInput } from '@/domain/mitarbeiter/features/anlageassistent/types/types';

export const anlageassistentFormDefaultValues = {
  person: {
    persoenliches: {
      anrede: undefined,
      vorname: '',
      nachname: '',
      rufname: undefined,
      personalnummer: undefined,
      e2nId: undefined,
    },
    kontakt: {
      email: undefined,
      mobilnummer: undefined,
      strict: false,
    },
    arbeitsbereiche: {
      primaererArbeitsbereich: '',
      sekundaereArbeitsbereiche: [],
      erfahrungslevel: undefined,
    },
  },
  anstellungsverhaeltnis: {
    anstellung: {
      anstellungstyp: '',
      eintrittsdatum: undefined,
      befristet: false,
      befristung: undefined,
    },
    fristen: [],
  },
  bezahlung: {
    bezahlungsart: {
      art: undefined,
      stundenlohn: '',
      monatsgehalt: undefined,
    },
    sollstunden: {
      sollstunden: undefined,
      berechnungsartMonat: undefined,
      monatsstunden: '',
      unbezahlteUeberstundenMonat: undefined,
      wochenstunden: '',
      unbezahlteUeberstundenWoche: undefined,
      arbeitstage: [],
      tagessoll: undefined,
    },
    zuschlaege: {
      zuschlaege: undefined,
      zuschlagsgruppe: undefined,
      pauschaleZuschlaege: undefined,
      uebertariflicheZahlung: undefined,
      strict: false,
    },
  },
  abwesenheiten: {
    allgemein: {
      anzahlUrlaubstage: '',
      anzahlArbeitstage: undefined,
      stundenBewertung: undefined,
      stunden: undefined,
      dynamisch: undefined,
      dynamisch_wochenschnitt_start: undefined,
      dynamisch_wochenschnitt_limitieren: undefined,
      dynamisch_drei_monatsschnitt_berechnungsgrundlage: undefined,
    },
    guttage: {
      guttageBewerten: false,
    },
    feiertagseinstellungen: {
      zuschlagsregelungGreift: false,
      stundenGutschreibung: false,
      taeglicheArbeitszeitAuffuellen: false,
    },
  },
} satisfies FormInput as FormInput;
